"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const styleOverrides = {
  root: ({
    theme
  }) => ({
    backgroundColor: theme.palette.default.main,
    color: theme.palette.default.contrastText
  })
};
var _default = exports.default = {
  styleOverrides
};
